import React from 'react';
import { IconProps } from './types';

export const TimesCircleIcon: React.FC<IconProps> = ({
  size = '18',
  color = 'text-interfaceColor-100',
  strokeWidth = 1.2,
  classNames = '',
}) => {
  return (
    <svg
      className={`w-${size} h-${size} stroke-current ${color} ${classNames}`}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4229 6.57714L6.57714 11.4229"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.57714 6.57714L11.4229 11.4229"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 16.4286C13.1027 16.4286 16.4286 13.1027 16.4286 9C16.4286 4.89731 13.1027 1.57143 9 1.57143C4.89731 1.57143 1.57143 4.89731 1.57143 9C1.57143 13.1027 4.89731 16.4286 9 16.4286Z"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
